import { addDays } from 'date-fns';
import { useState } from 'react';
import { useIsFrench } from 'src/common/contexts/language-context';
import { useFeatureIsOn } from 'src/common/growthbook';
import { StyledButton, StyledCookieBanner, StyledLink, StyledText } from 'src/features/cookie-consent/cookie-consent.styles';
import Cookies from 'universal-cookie';
export const CookieConsent = () => {
  const cookies = new Cookies();
  const [showBanner, setShowBanner] = useState(!cookies.get('cookieconsent_status'));
  const isFrenshLanguage = useIsFrench();
  const isCookieBotEnabled = useFeatureIsOn('show-cookie-consent'); // CookieBot Banner
  const showCustomBanner = showBanner && !isCookieBotEnabled;
  const handleDismissCookieConsent = () => {
    const expirationDate = addDays(new Date(), 365);
    cookies.set('cookieconsent_status', 'dismiss', {
      path: '/',
      expires: expirationDate
    });
    setShowBanner(false);
  };
  return isFrenshLanguage ? <StyledCookieBanner showBanner={showCustomBanner}>
      <StyledText>
        Nous utilisons des cookies pour vous garantir la meilleure expérience utilisateur. Pour plus d'informations,
        contactez-nous.
      </StyledText>
      <StyledLink target="_blank" to="/legal/terms-of-use">
        En savoir plus
      </StyledLink>
      <StyledButton variant="solid" color="primary" onClick={handleDismissCookieConsent}>
        Compris !
      </StyledButton>
    </StyledCookieBanner> : <StyledCookieBanner showBanner={showCustomBanner}>
      <StyledText>
        We use cookies to ensure you get the best user experience. For more information contact us.
      </StyledText>
      <StyledLink target="_blank" to="/legal/terms-of-use">
        Read more
      </StyledLink>
      <StyledButton variant="solid" color="primary" onClick={handleDismissCookieConsent}>
        Got it!
      </StyledButton>
    </StyledCookieBanner>;
};